module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('h2', {
    staticClass: "h-l event-title"
  }, [_vm._v("upcoming programs")]), _c('div', {
    staticClass: "eventsContainer"
  }, _vm._l((_vm.programs), function(program) {
    return _c('div', {
      staticClass: "preview"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: _vm.programCategory(program),
            id: program.uid
          }
        }
      }
    }, [_c('div', {
      staticClass: "events-hero"
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": program.mainImage,
        "alt": program.content.title
      }
    })]), _c('div', {
      staticClass: "eventCaptions"
    }, [_c('h2', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(_vm.title(program)))]), _c('div', {
      staticClass: "dateTime"
    }, [_c('h3', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))])])])])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dd199b3"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HomeEvents.vue
// module id = 224
// module chunks = 1